//function to remove dynamicX from filter dictionary
export function removeDynamicX(filterdict: any) {
    const { DynamicXaxis, ...remainingFilters } = filterdict.filters; 
    return {
      ...filterdict, 
      filters: remainingFilters, 
    };
  }
  